<template>
  <div class="barra-acoes">
    <div class="filtros-busca">
      <button
        class="btn-filtros"
        @click="mostrarFiltros = true"
      >
        <img
          src="@/assets/icons/filter.png"
          alt="filtros"
          width="20"
          height="20"
        />
        Filtros
      </button>
      <FiltrosNoticias
        v-if="popupFiltroHandler('noticia')"
        :filtrosIniciais="props.filtrosIniciais"
        @fechar="mostrarFiltros = false"
        @aplicarFiltros="handlerAplicarFiltros"
      />
      <FiltroAtividade
        v-if="popupFiltroHandler('atividade')"
        :filtrosIniciais="props.filtrosIniciais"
        @fechar="mostrarFiltros = false"
        @aplicarFiltros="handlerAplicarFiltros"
      />
      <FiltrosTarefas
        v-if="popupFiltroHandler('tarefa')"
        @fechar="mostrarFiltros = false"
        @aplicarFiltros="handlerAplicarFiltros"
      />
      <FiltrosAcoes
        v-if="popupFiltroHandler('acao')"
        :filtrosIniciais="props.filtrosIniciais"
        @fechar="mostrarFiltros = false"
        @aplicarFiltros="handlerAplicarFiltros"
      />
      <FiltrosVagas
        v-if="popupFiltroHandler('vaga')"
        :filtrosIniciais="ultimosFiltrosVagas"
        @fechar="mostrarFiltros = false"
        @aplicarFiltros="handlerAplicarFiltros"
      />
      <FiltrosParcerias
        v-if="popupFiltroHandler('parceria')"
        :filtrosIniciais="props.filtrosIniciais"
        @fechar="mostrarFiltros = false"
        @aplicarFiltros="handlerAplicarFiltros"
      />
      <ModalAcoesCurricularizadas
        :mostrar="modalCurricularizadasVisivel"
        @fechar="modalCurricularizadasVisivel = false"
      />
      <SearchInput
        v-model="termoBusca"
        @pesquisar="enviarTermoBusca"
      />
      <slot name="after-search"></slot>
    </div>
    <div class="acoes-direita">
      <!-- Select de Unidade no topo direito (apenas em Notícias Gerais) -->
      <div
        v-if="props.nomeTela === 'noticia' && !viaAcao"
        class="select-unidade-wrapper"
      >
        <FiltroSelect
          :items="unidades"
          :msg-todos="'Todas as unidades'"
          v-model="unidadeSelecionada"
          :tamanho="'pequeno'"
          @change="onSelecionarUnidade"
        />
      </div>

      <!-- Botão Listar Vagas de Ações Curricularizadas (exibido apenas na tela GERAL de vagas) -->
      <button
        v-if="props.nomeTela === 'vaga' && !viaAcao"
        class="btn-toggle-curricularizadas"
        @click="abrirCurricularizadas"
        title="Listar Ações Curriculares de Extensão"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
          <path d="M6 12v5c3 3 9 3 12 0v-5" />
        </svg>
        <span>Listar Ações Curriculares de Extensão</span>
      </button>

      <!-- Modal para Usuário Não Logado -->
      <div
        v-if="mostrarModalLogin"
        class="modal-overlay"
        @click.self="mostrarModalLogin = false"
      >
        <div class="modal-login-card">
          <div class="modal-login-header">
            <div class="modal-icon-wrapper">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                <polyline points="10 17 15 12 10 7"></polyline>
                <line
                  x1="15"
                  y1="12"
                  x2="3"
                  y2="12"
                ></line>
              </svg>
            </div>
            <h3>Atenção</h3>
          </div>
          <div class="modal-login-body">
            <p>
              Para entrar em contato com os coordenadores desta ação, por favor
              faça login.
            </p>
          </div>
          <div class="modal-login-footer">
            <button
              class="btn-modal-ok"
              @click="mostrarModalLogin = false"
            >
              OK
            </button>
            <button
              class="btn-modal-entrar"
              @click="irParaLogin"
            >
              Entrar
            </button>
          </div>
        </div>
      </div>

      <!-- Toggle Aceitando Curricularização (exibido quando vier por AÇÃO e tiver acoesCurricularizadas não vazio - visível a todos, alterável apenas por Coordenadores) -->
      <div
        v-if="props.nomeTela === 'vaga' && viaAcao && temAcoesCurricularizadas"
        class="toggle-curricularizacao-acao"
        :class="{
          aceitando: aceitandoCurricularizacao,
          readonly: !props.isCoordenador,
        }"
        @click="toggleAceiteCurricularizacao"
        :title="
          aceitandoCurricularizacao
            ? 'Vagas curriculares disponíveis'
            : 'Vagas curriculares indisponíveis'
        "
      >
        <span class="status-indicator"></span>
        <span class="toggle-label">
          {{
            aceitandoCurricularizacao
              ? "Vagas curriculares disponíveis"
              : "Vagas curriculares indisponíveis"
          }}
        </span>
        <div class="switch-track">
          <div class="switch-thumb"></div>
        </div>
      </div>

      <button
        v-if="
          props.isCoordenador &&
          props.nomeTela !== 'parceria' &&
          $route.path.includes(props?.nomeTela)
        "
        @click="abriModal()"
        class="btn-publicar"
      >
        Publicar {{ props.nomeTela }}
      </button>
    </div>
  </div>
</template>
<script setup>
import { ref, watch, computed } from "vue";
import { useRoute } from "vue-router";
import FiltrosNoticias from "@/components/noticias/FiltrosNoticias.vue";
import FiltroAtividade from "@/components/atividades/FiltroAtividade.vue";
import FiltrosTarefas from "@/components/tarefas/FiltrosTarefas.vue";
import FiltrosAcoes from "@/components/acoes/FiltrosAcoes.vue";
import FiltrosParcerias from "@/components/modals/FiltrosParcerias.vue";
import router from "@/router";
import FiltrosVagas from "@/components/vagas/FiltrosVagas.vue";
import ModalAcoesCurricularizadas from "@/components/acoes/ModalAcoesCurricularizadas.vue";
import acaoService from "@/service/acaoService";
import unidadesService from "@/service/unidadesService";
import { formatarEnum } from "@/utils/FormatarEntradas";
import { onMounted } from "vue";
import { useAuthStore } from "@/stores/auth";
import { storeToRefs } from "pinia";
import userInfos from "@/utils/userInfos";
import SearchInput from "../layout/SearchInput.vue";
import FiltroSelect from "./FiltroSelect.vue";

const props = defineProps({
  nomeTela: String,
  isCoordenador: Boolean,
  filtrosIniciais: {
    type: Object,
    default: () => ({}),
  },
  termoBuscaInicial: {
    type: String,
    default: "",
  },
});

const route = useRoute();
const viaAcao = computed(
  () => !!route.params.id || (route.path && route.path.includes("/acao/"))
);
const acaoIdAtual = computed(() => route.params.id);

const authStore = useAuthStore();
const { isAutenticado, estaRenovando } = storeToRefs(authStore);
const isLogado = computed(() => isAutenticado.value || estaRenovando.value);

const mostrarFiltros = ref(false);
const modalCurricularizadasVisivel = ref(false);
const mostrarModalLogin = ref(false);

function abrirCurricularizadas() {
  modalCurricularizadasVisivel.value = true;
  const user = userInfos.getUserInfos();
  if (!user && !isLogado.value) {
    mostrarModalLogin.value = true;
  }
}

function irParaLogin() {
  router.push("/login");
}
const termoBusca = ref(props.termoBuscaInicial);
const aceitandoCurricularizacao = ref(true);
const temAcoesCurricularizadas = ref(false);
const unidades = ref([]);
const unidadeSelecionada = ref(
  props.filtrosIniciais?.unidadeId || route.query.unidadeId || ""
);

watch(
  () => [props.filtrosIniciais?.unidadeId, route.query.unidadeId],
  ([newProp, newQuery]) => {
    unidadeSelecionada.value = newProp || newQuery || "";
  }
);

onMounted(async () => {
  try {
    const lista = await unidadesService.getAllUnidades(0, 1000);
    if (lista && Array.isArray(lista)) {
      unidades.value = lista;
    }
  } catch (e) {
    console.error("Erro ao carregar unidades em FiltrosComponent:", e);
  }
});

function onSelecionarUnidade() {
  const query = { ...route.query };
  if (unidadeSelecionada.value) {
    query.unidadeId = unidadeSelecionada.value;
  } else {
    delete query.unidadeId;
  }
  query.page = 0;
  router.replace({ query });
}

watch(
  acaoIdAtual,
  async (newId) => {
    if (newId) {
      try {
        const res = await acaoService.getAcoesById(newId);
        const acao = res?.data || res;
        if (acao) {
          // Verificar se o campo acoesCurricularizadas não está vazio
          const campoCurricular =
            acao.acoesCurricularizadas ??
            acao.acaoCurricularizada ??
            acao.acoesCurricularizada;
          if (Array.isArray(campoCurricular)) {
            temAcoesCurricularizadas.value = campoCurricular.length > 0;
          } else if (typeof campoCurricular === "boolean") {
            temAcoesCurricularizadas.value = campoCurricular;
          } else if (
            campoCurricular !== undefined &&
            campoCurricular !== null
          ) {
            temAcoesCurricularizadas.value = Boolean(campoCurricular);
          } else {
            temAcoesCurricularizadas.value = false;
          }

          const valorCurricular =
            acao.curricularizada ??
            acao.isCurricularizada ??
            acao.curricularizacao;
          if (valorCurricular !== undefined && valorCurricular !== null) {
            aceitandoCurricularizacao.value = Boolean(valorCurricular);
            localStorage.setItem(
              `aceitandoCurricularizacao_${newId}`,
              aceitandoCurricularizacao.value.toString()
            );
            return;
          }
        }
      } catch (error) {
        console.error(
          "Erro ao verificar campo curricularizada da ação:",
          error
        );
      }

      const salvo = localStorage.getItem(`aceitandoCurricularizacao_${newId}`);
      if (salvo !== null) {
        aceitandoCurricularizacao.value = salvo === "true";
      }
    } else {
      temAcoesCurricularizadas.value = false;
    }
  },
  { immediate: true }
);

async function toggleAceiteCurricularizacao() {
  if (!props.isCoordenador) return;
  const novoEstado = !aceitandoCurricularizacao.value;

  // Atualiza localmente/otimisticamente
  aceitandoCurricularizacao.value = novoEstado;

  if (acaoIdAtual.value) {
    try {
      await acaoService.atualizarCurricularizada(acaoIdAtual.value, novoEstado);
      localStorage.setItem(
        `aceitandoCurricularizacao_${acaoIdAtual.value}`,
        novoEstado.toString()
      );
    } catch (error) {
      console.error(
        "Erro ao atualizar status de curricularização no backend:",
        error
      );
      // Reverte estado em caso de erro na requisição
      aceitandoCurricularizacao.value = !novoEstado;
    }
  }
}

const emits = defineEmits(["aplicarFiltros", "pesquisar"]);

// Sincronizar termoBusca se a prop mudar
watch(
  () => props.termoBuscaInicial,
  (novoValor) => {
    termoBusca.value = novoValor;
  }
);

function abriModal() {
  router.push((name = `cadastrar-${props.nomeTela}`));
}

function popupFiltroHandler(nomeComponente) {
  return props.nomeTela === nomeComponente && mostrarFiltros.value;
}

const ultimosFiltrosVagas = ref({});

function handlerAplicarFiltros(filtros) {
  if (props.nomeTela === "vaga") {
    ultimosFiltrosVagas.value = { ...filtros };
  }
  emits("aplicarFiltros", filtros);
}

function enviarTermoBusca(termo) {
  emits("pesquisar", termo);
}
</script>
<style scoped>
.barra-acoes {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1.5rem 0rem;
  width: 100%;
}

.filtros-busca {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.btn-filtros {
  background: var(--branco);
  border: 1px solid var(--roxo-escuro1);
  border-radius: 5px;
  padding: 6px 14px;
  font-size: 0.85rem;
  cursor: pointer;
  color: var(--roxo-escuro1);
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-filtros img {
  filter: invert(17%) sepia(74%) saturate(2506%) hue-rotate(247deg)
    brightness(68%) contrast(104%);
}

.acoes-direita {
  display: flex;
  align-items: center;
  gap: 12px;
}

.select-unidade-wrapper {
  display: flex;
  align-items: center;
}

.select-unidade-topo {
  max-width: 190px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 6px 28px 6px 12px;
  border: 1px solid var(--roxo-escuro1);
  border-radius: 5px;
  font-size: 0.85rem;
  color: var(--roxo-escuro1);
  background: var(--branco);
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: 500;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23563578' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.select-unidade-topo:focus {
  border-color: var(--roxo-claro);
  box-shadow: 0 0 0 2px rgba(86, 53, 120, 0.15);
}

.select-unidade-topo.selecionado {
  border-color: #3b2078 !important;
  background-color: hsl(255, 50%, 97%) !important;
  color: #3b2078 !important;
  font-weight: 600 !important;
  box-shadow: 0 0 0 3px rgba(59, 32, 120, 0.08) !important;
}

.btn-toggle-curricularizadas {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--branco, #fff);
  border: 1px solid #d0c8e0;
  color: #666;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
}

.btn-toggle-curricularizadas:hover {
  border-color: var(--roxo-claro, #772fa2);
  color: var(--roxo-claro, #772fa2);
}

.btn-toggle-curricularizadas.ativo {
  background: #f3e8ff;
  border-color: var(--roxo-claro, #772fa2);
  color: var(--roxo-claro, #772fa2);
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(119, 47, 162, 0.15);
}

.toggle-curricularizacao-acao {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 20px;
  padding: 5px 14px;
  cursor: pointer;
  user-select: none;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.toggle-curricularizacao-acao:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.toggle-curricularizacao-acao.readonly {
  cursor: default;
}

.toggle-curricularizacao-acao.readonly:hover {
  box-shadow: none;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #94a3b8;
  transition:
    background-color 0.25s ease,
    box-shadow 0.25s ease;
}

.toggle-curricularizacao-acao.aceitando {
  background: #f3e8ff;
  border-color: var(--roxo-claro, #772fa2);
}

.toggle-curricularizacao-acao.aceitando .status-indicator {
  background-color: var(--roxo-claro, #772fa2);
  box-shadow: 0 0 6px rgba(119, 47, 162, 0.6);
}

.toggle-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: #64748b;
  transition: color 0.25s ease;
}

.toggle-curricularizacao-acao.aceitando .toggle-label {
  color: #513187;
}

.switch-track {
  width: 32px;
  height: 18px;
  background-color: #cbd5e1;
  border-radius: 10px;
  position: relative;
  transition: background-color 0.25s ease;
}

.toggle-curricularizacao-acao.aceitando .switch-track {
  background-color: var(--roxo-claro, #772fa2);
}

.switch-thumb {
  width: 14px;
  height: 14px;
  background-color: #ffffff;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.toggle-curricularizacao-acao.aceitando .switch-thumb {
  transform: translateX(14px);
}

.btn-publicar {
  background-color: var(--roxo-escuro1);
  color: var(--branco);
  border: none;
  border-radius: 5px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}

.btn-publicar:hover {
  opacity: 0.9;
}

/* ── Modal Usuário Não Logado ── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 16px;
}

.modal-login-card {
  background: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 420px;
  padding: 24px;
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: modalFadeIn 0.15s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.93) translateY(6px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-login-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-icon-wrapper {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: hsl(255, 50%, 95%);
  color: #3b2078;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-login-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.modal-login-body p {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;
  margin: 0;
}

.modal-login-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}

.btn-modal-ok {
  padding: 8px 20px;
  border-radius: 8px;
  border: 1.5px solid #d1d5db;
  background: #ffffff;
  color: #374151;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-modal-ok:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.btn-modal-entrar {
  padding: 8px 24px;
  border-radius: 8px;
  border: none;
  background: #3b2078;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(59, 32, 120, 0.2);
}

.btn-modal-entrar:hover {
  background: #2c175c;
  box-shadow: 0 4px 8px rgba(59, 32, 120, 0.3);
}
</style>
